import React, { useEffect, useState, useCallback, useMemo, useRef } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { v4 as uuidv4 } from 'uuid';

import RoomOutlinedIcon from '@mui/icons-material/RoomOutlined';

import MTClientRequirementCircleComponent from './MTClientRequirementCircleComponent';
import MTFooterComponent from './MTFooterComponent';

import MaterialDropDown from '../Components/Core/MaterialDropDown/MaterialDropDown';
import Spinner from '../Components/Spinner/Spinner';
import useQuery from '../hooks/useQuery';
import * as constNames from '../models/constant';
import { CUSTOM_CLIENT_NAME } from '../models/headers';
import { Routes as AppRoutes } from '../models/routes';
import * as actionTypes from '../store/actions/index';
import {
  calcCapacity,
  calcMonthTerms,
  formatDate,
  getDistanceFromLatLong,
  getCurrentLocationCoordinates,
  hasValidSurveyID,
} from '../utils/utils';

function MobileTotalOptionsComponent(props) {
  const [selectedPriceValue, setSelectedPriceValue] = useState('');
  const [isNotDesktop, setIsNotDesktop] = useState(true);
  const [currentLocationsLatLongs, setCurrentLocationsLatLongs] = useState([]);
  const resultArrayRef = useRef([]);
  const query = useQuery();
  const { surveyId } = useParams();
  const [IsSpinner, SetIsSpinner] = useState(false);

  const data = useSelector((state) => state?.optRed?.data);
  const pdfDownload = useSelector((state) => state?.comRed?.pdfDownload);
  const currentDeal = useSelector((state) => state?.comRed?.currentDeal);
  const clientCurrentLocation = useSelector((state) => state?.comRed?.displayCurrentLocation);

  const pathParams = useHistory()?.location?.pathname?.split('/');

  const history = useHistory();

  const surveyData = data;

  const dispatch = useDispatch();

  const isShortlisted = query.get(constNames.IS_SHORTLISTED);

  useEffect(() => {
    if (
      !pdfDownload &&
      Object.keys(data)?.length === 0 &&
      surveyId
      // hasValidSurveyID(surveyId)
    ) {
      SetIsSpinner(true);
      dispatch(actionTypes.providerAction(surveyId, isShortlisted, false, false));
    }
  }, [data, dispatch, isShortlisted, pdfDownload, surveyId]);

  useEffect(() => {
    if (Object.keys(currentDeal)?.length > 0) {
      SetIsSpinner(false);
    }
  }, [currentDeal]);

  const setFloorPlanImage = (option) => {
    if (option && option?.floorPlan) {
      return option?.floorPlan.replace(
        process.env.REACT_APP_PDF_IMAGE_URL.trim(),
        process.env.REACT_APP_PDF_REPLACE_IMAGE_URL.trim(),
      );
    }
    if (option && option?.floorPlan && option?.floorPlan?.includes('us-east-1')) {
      return option?.floorPlan.replace(
        process.env.REACT_APP_PDF_HERO_IMAGE_URL.trim(),
        process.env.REACT_APP_PDF_REPLACE_IMAGE_URL.trim(),
      );
    }
  };

  const onPriceChange = (text) => {
    setSelectedPriceValue(text);
  };

  useEffect(() => {
    const fetchData = async () => {
      if (clientCurrentLocation) {
        const currentLocationCoordinates = await getCurrentLocationCoordinates(
          clientCurrentLocation,
        );

        if (currentLocationCoordinates.data.results.length > 0) {
          const currentCoordinates = [
            currentLocationCoordinates.data.results[0].geometry.location.lng,
            currentLocationCoordinates.data.results[0].geometry.location.lat,
          ];
          // Do something with the currentCoordinates here

          setCurrentLocationsLatLongs(currentCoordinates);
        }
      }
    };

    fetchData();
  }, [clientCurrentLocation]);

  const getDistance = (option, unitVal) => {
    if (option && option.lat && option.lng && currentLocationsLatLongs) {
      const latLng = currentLocationsLatLongs;

      if (latLng && latLng.length > 0) {
        const lat1 = latLng[1];
        const lat2 = option.lat;
        const lon1 = latLng[0];
        const lon2 = option.lng;
        const distance1 = Math.round(getDistanceFromLatLong(lat1, lon1, lat2, lon2, unitVal));

        const unit = unitVal == 'miles' ? 'Miles ' : 'KM ';

        return (
          <div className="distanceContentWrapper">
            <span>{distance1}</span> {unit} {'from current location'}
          </div>
        );
      }

      return '';
    }

    return '';
  };

  const handleOptionWrapper = (event, id) => {
    event.stopPropagation();
    history.push(`${AppRoutes.MOBILE_BASE}/${pathParams[3]}/options/${id}`);
  };

  let monthTermArray = [];

  if (data?.optionProviderRequestList?.length > 0) {
    monthTermArray = data?.optionProviderRequestList?.map((option, i) => {
      const optionID = option?.optionOrder;

      let rateVariableTerm = '';
      let monthTerms = {
        rateOneMonth: '',
        rateSixMonths: '',
        rateTwelveMonths: '',
        ratetwentyfourmonths: '',
        rateVariable: '',
      };

      if (option && option?.availableSpaceList) {
        monthTerms = calcMonthTerms(option);
      }

      if (option && option?.rateVariableTerm) {
        rateVariableTerm = option?.rateVariableTerm?.split(' ')[0]?.trim();
      }

      monthTerms['labelOneMonth'] = '1 Month';
      monthTerms['labelSixMonths'] = '6 Months';
      monthTerms['labelTwelveMonths'] = '12 Months';
      monthTerms['labelTwentyFourMonths'] = '24 Months';

      return { optionID, monthTerms, rateVariableTerm };
    });
  }

  const selectPricingOptions = useCallback(
    (option, index) => {
      const resultArray = [];
      const monthTerm = monthTermArray?.[index]?.monthTerms;

      if (option?.ratesToInclude && option?.ratesToInclude?.includes('1')) {
        resultArray.push({
          text: (
            <div className="hibrid-select-wrapper">
              <div>{monthTerm?.labelOneMonth}</div>
              <div>{monthTerm?.rateOneMonth}</div>
            </div>
          ),

          value: `${monthTerm?.labelOneMonth} ${monthTerm?.rateOneMonth}`,
          month: 1,
        });
      }

      if (option?.ratesToInclude && option?.ratesToInclude?.includes('6')) {
        resultArray.push({
          text: (
            <div className="hibrid-select-wrapper">
              <div>{monthTerm?.labelSixMonths}</div>
              <div>{monthTerm?.rateSixMonths}</div>
            </div>
          ),
          value: `${monthTerm?.labelSixMonths} ${monthTerm?.rateSixMonths}`,
          month: 6,
        });
      }

      if (option?.ratesToInclude && option?.ratesToInclude?.includes('12')) {
        resultArray.unshift({
          text: (
            <div className="hibrid-select-wrapper">
              <div>{monthTerm?.labelTwelveMonths}</div>
              <div>{monthTerm?.rateTwelveMonths}</div>
            </div>
          ),
          value: `${monthTerm?.labelTwelveMonths} ${monthTerm?.rateTwelveMonths}`,
          month: 12,
        });
      }

      if (option?.ratesToInclude && option?.ratesToInclude?.includes('24')) {
        resultArray.push({
          text: (
            <div className="hibrid-select-wrapper">
              <div>{monthTerm?.labelTwentyFourMonths}</div>
              <div>{monthTerm?.ratetwentyfourmonths}</div>
            </div>
          ),
          value: `${monthTerm?.labelTwentyFourMonths} ${monthTerm?.ratetwentyfourmonths}`,
          month: 24,
        });
      }

      if (
        option?.ratesToInclude &&
        option?.ratesToInclude?.includes(monthTermArray?.[index]?.rateVariableTerm) &&
        monthTermArray?.[index]?.rateVariableTerm !== '' &&
        monthTerm?.rateVariable !== ''
      ) {
        resultArray.push({
          text: (
            <div className="hibrid-select-wrapper">
              <div>{monthTermArray?.[index]?.rateVariableTerm} Months</div>
              <div>{monthTerm?.rateVariable}</div>
            </div>
          ),
          value: `${monthTermArray?.[index]?.rateVariableTerm} Months ${monthTerm?.rateVariable}`,
        });
      }

      resultArrayRef.current[index] = resultArray;

      return resultArray;
    },
    [monthTermArray],
  );

  const collectDefaultVal = useCallback((index) => {
    if (resultArrayRef.current?.length > 0) {
      let defaultValObj = resultArrayRef.current?.[index]?.find((obj, keyIndex) => {
        return obj?.month === 12;
      });

      if (typeof defaultValObj === 'undefined') {
        defaultValObj = resultArrayRef.current?.[index][0];
      }

      return defaultValObj.value;
    }
  }, []);

  return (
    <>
      {IsSpinner && <Spinner />}
      <AllOptionsMainWrapper>
        <PropertiesCount>
          Properties ({data?.optionProviderRequestList?.length || 0})
        </PropertiesCount>
        <OptionsLoopWrapper>
          {data?.optionProviderRequestList?.length > 0 &&
            data?.optionProviderRequestList?.map((option, index) => (
              <OptionWrapper key={'Option ' + index}>
                <OptionImageWrapper>
                  <img
                    src={setFloorPlanImage(option)}
                    onClick={(e) => handleOptionWrapper(e, option.id)}
                  />
                </OptionImageWrapper>
                <OptionContentWrapper>
                  <OptionContentName onClick={(e) => handleOptionWrapper(e, option.id)}>
                    {index + 1}. {option?.optionName}
                  </OptionContentName>

                  <SelectPricingWrapper>
                    {option?.availableSpaceList?.[0]?.currency && (
                      <>
                        <SelectPricingDeskBlock>
                          <MaterialDropDown
                            label="Monthly Rent"
                            options={selectPricingOptions(option, index)}
                            onChange={(e) => onPriceChange(e)}
                            isNotDesktop={isNotDesktop}
                            selectedValue={selectedPriceValue || collectDefaultVal(index)}
                          ></MaterialDropDown>
                        </SelectPricingDeskBlock>
                        <SelectPricingMobBlock>
                          <SelectPricingMobChild
                            style={{
                              gridTemplateColumns: `repeat(${
                                option?.availableSpaceList?.[0]
                                  ? selectPricingOptions(option, index)?.length
                                  : 4
                              }, 1fr)`,
                            }}
                          >
                            {option.ratesToInclude && option.ratesToInclude.includes('12') && (
                              <SelectPricingMobChildObj key={uuidv4()}>
                                <SelectPricingMobChildMonth>
                                  {monthTermArray?.[index]?.monthTerms?.labelTwelveMonths}
                                </SelectPricingMobChildMonth>
                                <SelectPricingMobChildMonthVal>
                                  {monthTermArray?.[index]?.monthTerms?.rateTwelveMonths}
                                </SelectPricingMobChildMonthVal>
                              </SelectPricingMobChildObj>
                            )}

                            {option.ratesToInclude && option.ratesToInclude.includes('1') && (
                              <SelectPricingMobChildObj key={uuidv4()}>
                                <SelectPricingMobChildMonth>
                                  {monthTermArray?.[index]?.monthTerms?.labelOneMonth}
                                </SelectPricingMobChildMonth>
                                <SelectPricingMobChildMonthVal>
                                  {monthTermArray?.[index]?.monthTerms?.rateOneMonth}
                                </SelectPricingMobChildMonthVal>
                              </SelectPricingMobChildObj>
                            )}

                            {option.ratesToInclude && option.ratesToInclude.includes('6') && (
                              <SelectPricingMobChildObj key={uuidv4()}>
                                <SelectPricingMobChildMonth>
                                  {monthTermArray?.[index]?.monthTerms?.labelSixMonths}
                                </SelectPricingMobChildMonth>
                                <SelectPricingMobChildMonthVal>
                                  {monthTermArray?.[index]?.monthTerms?.rateSixMonths}
                                </SelectPricingMobChildMonthVal>
                              </SelectPricingMobChildObj>
                            )}

                            {option.ratesToInclude && option.ratesToInclude.includes('24') && (
                              <SelectPricingMobChildObj key={uuidv4()}>
                                <SelectPricingMobChildMonth>
                                  {monthTermArray?.[index]?.monthTerms?.labelTwentyFourMonths}
                                </SelectPricingMobChildMonth>
                                <SelectPricingMobChildMonthVal>
                                  {monthTermArray?.[index]?.monthTerms?.ratetwentyfourmonths}
                                </SelectPricingMobChildMonthVal>
                              </SelectPricingMobChildObj>
                            )}

                            {option.ratesToInclude &&
                              option.ratesToInclude.includes(
                                monthTermArray?.[index]?.rateVariableTerm,
                              ) &&
                              monthTermArray?.[index]?.rateVariableTerm !== '' && (
                                <SelectPricingMobChildObj key={uuidv4()}>
                                  <SelectPricingMobChildMonth>
                                    {option.rateVariableTerm !== ''
                                      ? `${monthTermArray?.[index]?.rateVariableTerm} Months`
                                      : null}
                                  </SelectPricingMobChildMonth>
                                  <SelectPricingMobChildMonthVal>
                                    {monthTermArray?.[index]?.monthTerms?.rateVariable !== ''
                                      ? monthTermArray?.[index]?.monthTerms?.rateVariable
                                      : null}
                                  </SelectPricingMobChildMonthVal>
                                </SelectPricingMobChildObj>
                              )}
                          </SelectPricingMobChild>
                        </SelectPricingMobBlock>
                      </>
                    )}
                  </SelectPricingWrapper>
                  <AvailabilityBlock>
                    <AvailabilityBlockHead>Availability</AvailabilityBlockHead>
                    <AvailabilityBlockDescWrapper>
                      <AvailabilityBlockDescCont>
                        Desks: {calcCapacity(option)}
                      </AvailabilityBlockDescCont>
                      <AvailabilityBlockDescCont>
                        Date: {formatDate(option)}
                      </AvailabilityBlockDescCont>
                    </AvailabilityBlockDescWrapper>
                  </AvailabilityBlock>
                  {currentLocationsLatLongs?.length > 0 && (
                    <CurrentLocationWrapper>
                      <RoomOutlinedIcon />
                      {currentDeal?.['Client Name']?.[0].toLowerCase() ===
                      CUSTOM_CLIENT_NAME.toLowerCase()
                        ? option && option.address && getDistance(option.address, 'km')
                        : option && option.address && getDistance(option.address, 'miles')}
                    </CurrentLocationWrapper>
                  )}
                </OptionContentWrapper>
              </OptionWrapper>
            ))}
        </OptionsLoopWrapper>
      </AllOptionsMainWrapper>

      <MTClientRequirementCircleComponent
        cssState={{ right: '100px' }}
        surveyData={surveyData}
        currentDeal={currentDeal}
      />
      <MTFooterComponent />
    </>
  );
}

const AllOptionsMainWrapper = styled.div`
  background-color: #fff;
  padding: 15px 15px 60px;
  margin: 0 auto;
  @media (orientation: ${constNames.DEVICE_ORIENTATION.LANDSCAPE}) {
    width: calc(100% - 30px);
  }
  @media ${constNames.DEVICE_MEDIA.TABLET_MIN} and (orientation: ${constNames.DEVICE_ORIENTATION
      .POTRAIT}) {
    width: 575px;
  }
  @media ${constNames.DEVICE_MEDIA.TABLET_MIN} and (orientation: ${constNames.DEVICE_ORIENTATION
      .LANDSCAPE}) {
    width: 615px;
  }
`;

const PropertiesCount = styled.div`
  font-size: 24px;
  font-weight: 500;
  margin-bottom: 10px;
`;

const PropertiesHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  margin: 0 0 15px;
  align-items: center;
`;
const PropertiesHeaderRight = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  padding: 7px 10px;
  border-radius: 10px;
  background-color: rgba(26, 26, 26, 4%);
  text-decoration: underline;
  & img {
    margin-left: 5px;
  }
`;

const OptionsLoopWrapper = styled.div``;

const OptionWrapper = styled.div`
  background-color: #fff;
  padding: 5px 10px 5px 5px;
  margin: 0 0 15px;
  border-radius: 10px;
  box-shadow: 5px 0px 5px rgba(0, 0, 0, 0.1), -5px 0px 5px rgba(0, 0, 0, 0.1),
    0px 5px 5px rgba(0, 0, 0, 0.1);
  display: grid;
  grid-template-columns: 130px 1fr;
  @media (orientation: ${constNames.DEVICE_ORIENTATION.LANDSCAPE}),
    ${constNames.DEVICE_MEDIA.TABLET_MIN} and (orientation: ${constNames.DEVICE_ORIENTATION
      .POTRAIT}) {
    grid-template-columns: 130px 1fr;
  }
`;

const OptionImageWrapper = styled.div`
  position: relative;
  display: flex;
  algin-items: center;
  justify-content: center;
  & img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 10px;
    border: solid 1px #d8d8d8;
    min-height: 195px;
    @media (orientation: ${constNames.DEVICE_ORIENTATION.LANDSCAPE}),
      ${constNames.DEVICE_MEDIA.TABLET_MIN} and (orientation: ${constNames.DEVICE_ORIENTATION
        .POTRAIT}) {
      min-height: 230px;
    }
  }
`;

const OptionContentWrapper = styled.div`
  width: calc(100% - 10px);
  display: flex;
  margin-left: 10px;
  align-items: center;
  flex-wrap: wrap;
`;

const OptionContentName = styled.div`
  margin: 5px 0 4px 0;
  color: #000;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: -0.12px;
  margin-bottom: 5px;
  width: 100%;
  white-space: pre-wrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  @media (orientation: ${constNames.DEVICE_ORIENTATION.LANDSCAPE}),
    ${constNames.DEVICE_MEDIA.TABLET_MIN} and (orientation: ${constNames.DEVICE_ORIENTATION
      .POTRAIT}) {
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    margin-top: 5px;
  }
`;

const OptionContentSpaceDesc = styled.div`
  font-size: 9px;
  @media (orientation: ${constNames.DEVICE_ORIENTATION.LANDSCAPE}),
    ${constNames.DEVICE_MEDIA.TABLET_MIN} and (orientation: ${constNames.DEVICE_ORIENTATION
      .POTRAIT}) {
    font-size: 14px;
  }
`;

const SelectPricingWrapper = styled.div`
  width: 100%;
  margin: 0 0 8px;
`;

const SelectPricingDeskBlock = styled.div`
  display: flex;
  & .MuiInputLabel-root {
    color: rgba(26, 26, 26, 0.6) !important;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px;
  }
  & .MuiInputLabel-formControl {
    top: -4px;
  }
  & .MuiInputLabel-formControl.MuiInputLabel-shrink {
    top: 1px;
    left: -4px;
  }
  & .MuiOutlinedInput-root {
    padding: 0 !important;
    & .MuiSelect-select {
      color: rgba(26, 26, 26, 0.6) !important;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 21px;
      padding: 12px 14px;
    }
    & .hibrid-select-wrapper {
      display: grid;
      grid-template-columns: 1fr 1fr;
    }
    & path {
      color: rgba(26, 26, 26, 0.6) !important;
    }
  }
  @media (orientation: ${constNames.DEVICE_ORIENTATION.LANDSCAPE}),
    ${constNames.DEVICE_MEDIA.TABLET_MIN} and (orientation: ${constNames.DEVICE_ORIENTATION
      .POTRAIT}) {
    display: none;
  }
`;
const SelectPricingMobBlock = styled.div`
  display: grid;
  @media ${constNames.DEVICE_MEDIA.MOBILE_MAX} and (orientation: ${constNames.DEVICE_ORIENTATION
      .POTRAIT}) {
    display: none;
  }
`;

const SelectPricingMobChild = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
`;

const SelectPricingMobChildObj = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  justify-content: center;
  align-items: center;
  &:first-child div:first-child {
    font-weight: 500;
  }
`;
const SelectPricingMobChildMonth = styled.div`
  font-size: 14px;
  font-weight: 400;
  margin: 0 0 5px;
`;
const SelectPricingMobChildMonthVal = styled.div`
  font-size: 12px;
  font-weight: 400;
`;

const AvailabilityBlock = styled.div`
  margin-bottom: 8px;
  width: 100%;
`;

const AvailabilityBlockHead = styled.div`
  color: #212121;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: -0.14px;
  margin-bottom: 8px;
  @media (orientation: ${constNames.DEVICE_ORIENTATION.LANDSCAPE}),
    ${constNames.DEVICE_MEDIA.TABLET_MIN} and (orientation: ${constNames.DEVICE_ORIENTATION
      .POTRAIT}) {
    font-size: 16px;
  }
`;

const AvailabilityBlockDescWrapper = styled.div`
  display: grid;
  grid-template-columns: 40% 1fr;
  @media (orientation: ${constNames.DEVICE_ORIENTATION.LANDSCAPE}),
    ${constNames.DEVICE_MEDIA.TABLET_MIN} and (orientation: ${constNames.DEVICE_ORIENTATION
      .POTRAIT}) {
    grid-template-columns: 30% 1fr;
  }
`;

const AvailabilityBlockDescCont = styled.div`
  color: rgba(33, 33, 33, 0.6);
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 8px;
  @media (orientation: ${constNames.DEVICE_ORIENTATION.LANDSCAPE}),
    ${constNames.DEVICE_MEDIA.TABLET_MIN} and (orientation: ${constNames.DEVICE_ORIENTATION
      .POTRAIT}) {
    font-size: 14px;
  }
`;

const CurrentLocationWrapper = styled.div`
  display: grid;
  grid-template-columns: 20px 1fr;
  align-items: flex-start;
  color: rgba(26, 26, 26, 0.6);
  font-family: Calibre-R;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.06px;
  & svg {
    width: 16px;
    height: 16px;
    color: #000;
  }
  & .distanceContentWrapper {
    display: flex;
    align-items: flex-start;
    & span {
      font-weight: 500;
      color: #1a1a1a;
      margin-right: 5px;
    }
  }
`;

export default MobileTotalOptionsComponent;
